import type { SignalMetadataDto } from '@/feature/signals/api.types';
import { getSignalMetaData } from '@/feature/signals/metadata';
import type { AlarmDto } from './api.types';

export const sortAscending = (a: AlarmDto, b: AlarmDto) =>
  new Date(a.eventTriggered).getTime() - new Date(b.eventTriggered).getTime();

export const getBreachBaseSignalName = (
  alarm: AlarmDto | undefined,
  metadata: SignalMetadataDto[] | undefined
): string | undefined =>
  alarm?.breachDetails?.signalNames
    .map(
      (name) =>
        getSignalMetaData(name, metadata).baseSignalMetadata?.baseSignalName
    )
    .find(Boolean);
